import { Address, Maybe } from '@/types';
import { CartDeliveryAddress } from '@agrantis/cart';

export const addressToOrderAddress = (
  address: Maybe<Omit<Address, 'owner' | 'ownerId'>> | undefined,
  firstName?: string | undefined | null,
  lastName?: string | undefined | null,
) => {
  if (!address) return undefined;

  const {
    addressLine1,
    addressLine2,
    addressLocality,
    addressPostcode,
    addressDistrict,
  } = address;

  const returnAddress: CartDeliveryAddress = {
    addressLine1: addressLine1 ?? '',
    addressLine2: addressLine2 ?? '',
    addressLocality: addressLocality ?? '',
    addressPostcode: addressPostcode ?? '',
    addressDistrict: addressDistrict ?? '',
    company: '',
    country: 'DE',
    firstName: firstName ?? '',
    lastName: lastName ?? '',
  };
  return returnAddress;
};
